module.exports = Promise.all([__parcel__import__("9Vv5s"), __parcel__import__("6m7fQ")]).then(() => parcelRequire('g36Vt'));